// extracted by mini-css-extract-plugin
module.exports = {"testimonals":"FullTestimonials-styles-module--testimonals--2Eiwj","quotes":"FullTestimonials-styles-module--quotes--2Nv0w"};